// @vendors
const { get, each, isEmpty } = require('lodash');

// @utilities
const { recordProcess, PROC_END } = require('utilities/tagging');

// @track processes
const { PROC_ADD_SIMPLE_NOTE } = require('constants/mortgageRequestProcesses');

// @commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');

// @constants
const { NS_CLI } = require('constants/mortgageRequestDocumentsTypes');
const {
    MORTGAGE_REQUEST_SIMPLE_NOTE_REQUEST,
    MORTGAGE_REQUEST_SIMPLE_NOTE_SUCCESS,
    MORTGAGE_REQUEST_SIMPLE_NOTE_FAILURE,
    MORTGAGE_REQUEST_SIMPLE_NOTE_SAVE_REQUEST,
    MORTGAGE_REQUEST_SIMPLE_NOTE_SAVE_SUCCESS,
    MORTGAGE_REQUEST_SIMPLE_NOTE_ADD_FILE,
    MORTGAGE_REQUEST_SIMPLE_NOTE_RESET_STATE,
    MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_REQUEST,
    MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_SUCCESS,
    MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_FAILURE,
    MORTGAGE_REQUEST_SIMPLE_NOTE_UPLOAD_FILE_ERROR,
    MORTGAGE_REQUEST_ESTATES_DATA_RESET,
    MORTGAGE_REQUEST_ESTATES_DATA_FETCH_LIST_REQUEST,
    MORTGAGE_REQUEST_ESTATES_DATA_FETCH_LIST_SUCCESS,
    MORTGAGE_REQUEST_ESTATES_DATA_FETCH_LIST_FAILURE,
} = require('constants/actionTypes');

const requestSimpleNoteInProgress = () => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_REQUEST
});

const requestSimpleNoteSuccess = () => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_SUCCESS
});

const requestSimpleNoteFailure = error => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_FAILURE,
    data: { error }
});

const requestSimpleNoteUploadFilesInProgress = () => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_SAVE_REQUEST
});

const requestSimpleNoteSaveSuccess = () => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_SAVE_SUCCESS
});

const requestEstatesFetchAmmountInProgress = () => ({
    type: MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_REQUEST
});

const requestEstatesFetchAmmountSuccess = data => ({
    type: MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_SUCCESS,
    data
});

const requestEstatesFetchAmmountFailure = error => ({
    type: MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_FAILURE,
    data: { error }
});

const requestResetState = () => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_RESET_STATE
});

const requestResetEstatesDataState = () => ({
    type: MORTGAGE_REQUEST_ESTATES_DATA_RESET
});

const estatesDataFetchListInProgress = () => ({
    type: MORTGAGE_REQUEST_ESTATES_DATA_FETCH_LIST_REQUEST
});

const estatesDataFetchListSuccess = (data) => ({
    type: MORTGAGE_REQUEST_ESTATES_DATA_FETCH_LIST_SUCCESS,
    data
});

const estatesDataFetchListFailure = error => ({
    type: MORTGAGE_REQUEST_ESTATES_DATA_FETCH_LIST_FAILURE,
    data: { error }
});

// @Require simpleNote tramit
const requestSimpleNote = dispatch => {
    dispatch(requestSimpleNoteInProgress());
    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestSimpleNote'
    })
        .then(() => {
            recordProcess(PROC_ADD_SIMPLE_NOTE, PROC_END);
            dispatch(requestSimpleNoteSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestSimpleNoteFailure(response.error));
            } else {
                throw response;
            }
        });
};

const addFile = data => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_ADD_FILE,
    data
});

const uploadFileError = data => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_UPLOAD_FILE_ERROR,
    data
});

// @Save simpleNote documents
const sendFiles = obj => (dispatch, getState) => {
    const params = {
        index: obj.index || 0,
        documents: obj.documents,
        url: obj.url,
        fileType: obj.fileType,
        requestSimpleNotes: obj.requestSimpleNotes
    };

    if (params.index < params.documents.length) {
        const formData = new FormData();
        const doc = params.documents[params.index];

        const model = {
            tipoArchivo: params.fileType,
            bienId: doc.estateId
        };

        formData.append('files', doc.file);
        formData.append('model', new Blob(
            [ JSON.stringify(model) ],
            { type: 'application/json' }
        ));

        const requestData = {
            query: formData
        };

        return APIPost({
            dispatch,
            endpoint: 'mortgageRequesWorkDataFileMultipleSubmit',
            url: params.url,
            params: requestData,
            contentType: false
        })
            .then(() => {
                params.index++;
                dispatch(sendFiles(params));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(uploadFileError({
                        estateId: doc.estateId,
                        error: response.error
                    }));
                    params.index++;
                    dispatch(sendFiles(params));
                } else {
                    throw response;
                }
            });
    } else {
        dispatch(requestSimpleNoteSaveSuccess());

        const simpleNoteState = getState().mortgageRequestSimpleNote;

        if (params.requestSimpleNotes && simpleNoteState.get('errorUploading').size === 0) {
            requestSimpleNote(dispatch);
        }
    }
};

const uploadFiles = requestSimpleNotes => (dispatch, getState) => {
    const simpleNoteState = getState().mortgageRequestSimpleNote;
    if (!simpleNoteState.get('isUploading') && !simpleNoteState.get('isRequesting')) {
        const files = simpleNoteState.getIn(['files']).toJS();
        const fileType = NS_CLI;
        const url = apiURLBuilder.getURL('mortgageRequesWorkDataFileMultipleSubmit');
        const documents = [];

        !isEmpty(files) && each(files, (file, estateId) => {
            documents.push({
                estateId,
                file: file.file
            })
        });

        dispatch(requestSimpleNoteUploadFilesInProgress());
        dispatch(sendFiles({
            documents,
            url,
            fileType,
            requestSimpleNotes
        }));
    }
};

const resetState = () => dispatch => {
    dispatch(requestResetState());
    dispatch(requestResetEstatesDataState());
};

// @Get estates data
const fetchEstatesDataFilter = dataEstatesList => {
    const estatesList = get(dataEstatesList, 'data', []);
    const statesListFormated = {};
    each(estatesList, estate => {
        statesListFormated[estate.tipoBien] = statesListFormated[estate.tipoBien] || [];
        statesListFormated[estate.tipoBien].push(estate.bienId);
    });
    return statesListFormated;
};

const fetchEstatesData = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestEstatesData;

    if (!currentState.get('isFetching')) {
        dispatch(estatesDataFetchListInProgress());
        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestInmuebles'
        })
            .then(response => fetchEstatesDataFilter(response))
            .then(response => {
                dispatch(estatesDataFetchListSuccess(response));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(estatesDataFetchListFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve()
    }
};

// @Get estates count
const fetchEstatesAmmount = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestEstates;

    if (!currentState.get('isFetching')) {
        dispatch(requestResetEstatesDataState());
        dispatch(requestEstatesFetchAmmountInProgress());
        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestFetchEstatesAmmount'
        })
            .then(response => dispatch(requestEstatesFetchAmmountSuccess(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestEstatesFetchAmmountFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

module.exports = {
    uploadFiles,
    addFile,
    resetState,
    fetchEstatesAmmount,
    fetchEstatesData
};
